import footerLogo from "../../assets/logo.png";
import { Link } from "react-router-dom";
import { FaInstagram, FaYoutube, FaPinterestP } from "react-icons/fa";
import { FaThreads, FaXTwitter } from "react-icons/fa6";
import "./index.css";

const Footer = () => {
  return (
    <div className="footer-container">
      <div className="footer-logo-section">
        <div className="footer-divider-line"></div>
        <img src={footerLogo} alt="Icon" className="footer-logo" />
        <div className="footer-divider-line"></div>
      </div>
      <div className="footer-social-wrapper">
        <div className="footer-social-icons">
          <a href="https://www.instagram.com/clapkartelcinema/" target="_blank" rel="noopener noreferrer" className="icon-link">
            <div className="icon-wrapper instagram">
              <FaInstagram />
            </div>
          </a>
          <a href="https://www.threads.net/@clapkartelcinema" target="_blank" rel="noopener noreferrer" className="icon-link">
            <div className="icon-wrapper threads">
              <FaThreads />
            </div>
          </a>
          <a href="https://www.youtube.com/@ClapKartelCinema" target="_blank" rel="noopener noreferrer" className="icon-link">
            <div className="icon-wrapper youtube">
              <FaYoutube />
            </div>
          </a>
          <a href="https://x.com/ClapKartelCine" target="_blank" rel="noopener noreferrer" className="icon-link">
            <div className="icon-wrapper x-twitter">
              <FaXTwitter />
            </div>
          </a>
          <a href="https://www.pinterest.com/clapkartelcinema/" target="_blank" rel="noopener noreferrer" className="icon-link">
            <div className="icon-wrapper pinterest">
              <FaPinterestP />
            </div>
          </a>
        </div>
      </div>
      <div className="footer-text-section">
        <p className="footer-terms-text">
          <Link to="/terms-conditions" style={{ color: "inherit", textDecoration: "none", marginRight: "10px" }}>Terms & Conditions</Link> 
          <Link to="/privacy-policy" style={{ color: "inherit", textDecoration: "none" }}>Privacy Policy</Link>
        </p>
        <p className="footer-copyright-text">
          Copy Right © Clap Kartel. All Rights Reserved | Concept & Designed by
          eParivartan
        </p>
      </div>
    </div>
  );
};

export default Footer;